import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { map, Observable } from 'rxjs';
import { TableCurrentPageRowsSelectionDirective } from '../../directives/table-current-page-rows-selection.directive';

@Component({
  selector: 'app-table-header-current-page-row-selection-checkbox',
  imports: [CommonModule, CheckboxModule, FormsModule],
  templateUrl:
    './table-header-current-page-row-selection-checkbox.component.html',
  styleUrls: [
    './table-header-current-page-row-selection-checkbox.component.scss',
  ],
})
export class TableHeaderCurrentPageRowSelectionCheckboxComponent<
  Item,
  Filter,
  ItemAction,
  CollectionAction,
  Action,
> {
  private readonly tableRowsSelection = inject<
    TableCurrentPageRowsSelectionDirective<
      Item,
      Filter,
      ItemAction,
      CollectionAction,
      Action
    >
  >(TableCurrentPageRowsSelectionDirective);

  public readonly isChecked$: Observable<boolean>;

  public constructor() {
    this.isChecked$ = this.isCheckedSource();
  }

  public handleSelectionChange(isSelected: boolean): void {
    isSelected
      ? this.tableRowsSelection.selectAll()
      : this.tableRowsSelection.deselectAll();
  }

  private isCheckedSource(): Observable<boolean> {
    return this.tableRowsSelection.selectionChanges$.pipe(
      map(() => this.isChecked()),
    );
  }

  private isChecked(): boolean {
    return (
      this.tableRowsSelection.excludedIsEmpty() &&
      this.tableRowsSelection.isAllSelected
    );
  }
}
